import React from "react";
import { OrganizationFileCard } from "./OrganizationFileCard";

export function OrganizationFilePage({ history }) {
  return <OrganizationFileCard />;
}
